import {reactive} from "vue";
import ApontamentoEntidadeEvent from "@/domain/events/apontamentoEntidade.event";

class ItemClienteEvents {

    apontamentoEvent = new ApontamentoEntidadeEvent()


    listenerItemClienteGravado = reactive({value: {itemClienteId: ''}})
    listenerItemClienteAlterado = reactive({value: {itemClienteId: ''}})

    emitItemClienteGravado(itemClienteId: string) {
        this.listenerItemClienteGravado.value = {itemClienteId: itemClienteId}
    }

    emitItemClienteAlterado(itemClienteId: string) {
        this.listenerItemClienteAlterado.value = {itemClienteId: itemClienteId}
    }


}

export default ItemClienteEvents;